<template>
  <div>
    <alert-action-dialog v-if="!!alertData.ref_id" :dialog="showActionDialog" :status="status" :ref_id="alertData.ref_id" @toggle="toggle"  @alert:action-update="updateActions"></alert-action-dialog>

    <v-dialog v-model="showDialog" :fullscreen="!$vuetify.breakpoint.lgAndUp" width="800">
      <Card>
        <Toolbar>
          <v-toolbar-title>{{ $t('Alert Details') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </Toolbar>
        <v-card-text class="dialog-bg dialog-color">
          <v-layout wrap class="text-black">
            <v-flex xs12 md6>
              <v-tooltip top>
                <template slot='activator'>
                  <div class="caption mb-1 extraGrey--text text-truncate"># {{alertData.ref_id}}</div>
                </template>
                <span>{{alertData.ref_id}}</span>
              </v-tooltip>

              <div class="headline font-weight-bold primaryText--text">{{alertData.code}} </div>
              <div class="badges mt-3 mb-3">
                <span class="badge text-uppercase" :class="`badge-${alertData.status}`">{{alertData.status}}</span>
                <span class="badge text-uppercase badge-info">{{alertData.equipment}}</span>
              </div>
              <div class="primaryText--text"><span class="font-weight-bold">{{ $t('Device') }}: </span>{{alertData.name ? alertData.name : alertData.equipment_id}}</div>
              <div class="body-2 mt-3 primaryText--text"><span class="font-weight-bold">{{ $t('Message') }}: </span>{{alertData.message}}</div>
              <div class="meta mt-3">
                <div class="caption extraGrey--text">{{ $t('Created time') }}: {{alertData.created_time}}</div>
                <div class="caption extraGrey--text">{{ $t('Resolved time') }}: {{alertData.resolved_time}}</div>
                <div class="caption extraGrey--text">{{ $t('Added by') }}: {{alertData.added_by}}</div>
              </div>
            </v-flex>
            <v-flex xs12 md6 class="timeline-container">
              <v-timeline align-top dense>
                <v-timeline-item v-for="action in alertData.actions" :key="action._id" color="error darken-2"
                  :color="dotColor(action.action)" small left>
                  <v-card class="secondary primaryText--text">
                    <div class="body-2 ma-2 font-weight-bold">{{action.action}}</div>
                    <div class="caption ma-2">
                      <p class="mb-1">{{action.message}}</p>
                      <div class="text-align-right extraGrey--text">
                        {{ $t('Time') }}: {{convertToDateTime(action.time)}}
                      </div>
                      <div class="text-align-right extraGrey--text">
                        {{ $t('Updated by') }}: {{action.user}}
                      </div>
                    </div>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-flex>
          </v-layout>

        </v-card-text>

        <v-divider v-if="alertData.status !== 'resolved'"></v-divider>

        <v-card-actions v-if="alertData.status !== 'resolved'" class="footer-bg"
          :class="{'mobile-action': !$vuetify.breakpoint.lgAndUp}">
          <v-layout align-center justify-end>
            <v-btn v-if="alertData.equipment != 'grid' && alertData.equipment != 'gateway' && alertData.status === 'new'" class="primaryText--text" color="#F6B132" small @click="status = 'acknowledge'; showActionDialog = true">
              {{ $t('Acknowledge') }}
            </v-btn>
            <v-btn v-if="alertData.status !== 'resolved'" class="primaryText--text" color="#6BA751" small
              @click="status = 'resolved'; showActionDialog = true">
              {{ $t('Resolve') }}</v-btn>
          </v-layout>
        </v-card-actions>
      </Card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import AlertActionDialog from '@/components/Alert-v2/AlertActionDialog'
const momentTz = require('moment-timezone')

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    alert: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  components: {
    AlertActionDialog
  },
  data() {
    return {
      alertData: {},
      showDialog: false,
      showActionDialog: false,
      status: ''
    }
  },
  computed: {
    ...mapGetters([ 'getActivePlantTimezone' ])
  },
  mounted() {
    this.alertData = _.cloneDeep(this.alert)
  },
  methods: {
    convertToDateTime(unixTime) {
      return momentTz(unixTime, 'X').tz(this.getActivePlantTimezone).format('YYYY-MM-DD HH:mm:ss')
    },
    dotColor(state) {
      if (state === 'new') {
        return 'error'
      } else if (state === 'acknowledge') {
        return 'warning'
      } else if (state === 'resolved') {
        return 'success'
      }
      return 'info'
    },
    toggle(value) {
      this.showActionDialog = value
    },
    updateActions(val) {
      this.alertData.actions.push(val)
      this.alertData.status = val.action
    }
  },
  watch: {
    alert() {
      this.alertData = _.cloneDeep(this.alert)
    },
    dialog() {
      this.showDialog = this.dialog
    },
    showDialog() {
      this.$emit('toggleD', this.showDialog)
    }
  }
}
</script>

<style scoped>
.mobile-action {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
}

.theme--light .timeline-bg {
  color: black;
}

.text-align-right {
  text-align: right;
}

.badge {
  font-size: 0.9rem;
  min-width: 50px;
  padding: 0px 10px;
  margin: 0px 5px 0px 0px;
  border-radius: 50px;
  display: inline-block;
  text-align: center;
  color: white;
}

.badge-new {
  background-color: var(--v-error-base);
}

.badge-acknowledge {
  background-color: var(--v-warning-base);
}

.badge-resolved {
  background-color: var(--v-success-base);
}

.badge-info {
  background-color: var(--v-info-base);
}

.timeline-container {
    max-height: 300px;
    overflow: auto;
}
</style>
